import React, { useEffect, useState } from "react";
import VendorStore from "../../../components/atoms/vendorStores";
import TopRightLink from "../../../components/atoms/formFields/buttons/topRightLink";
import CardHeader from "../../../components/atoms/cardHeader";
import CardWrapper from "../../../components/molecules/CardWrapper";
import { Col, Row } from "antd";
import Variant from "./components/Variant";
import Sale from "./components/Sale";
import ProductDetails from "./components/ProductDetails";
import About from "./components/About";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { GetProductDetails } from "../../../store/thunks/productThunk";
import MediaSlider from "../../../components/atoms/mediaSlider";
import { detailsSaleListThunk } from "../../../store/thunks/InventoryThunk";
import TargetIndex from "./components/Target/TargetIndex";

const EditInventory = () => {
  const dispatch = useDispatch();
  const { id, base } = useParams();
  const location = useLocation();
  const { data } = useSelector((state) => state?.productDetails || {});
  const { storeId, storeName } = useSelector((state) => state?.storeData || {});
  const { Pagination, Filters } = location?.state || {};
  const { data: variantData } = useSelector(
    (state) => state?.detailsSaleList || {}
  );
  const [detail, setDetail] = useState({});
  const [inventoryValues, setInventoryValues] = useState({
    productId: id,
  });

    console.log("data detail",data)


  const {
    feedSupplementDetailedResponse,
    machineryDetailedResponse,
    productDetailedResponse,
    seedDetailedInformationResponse,
  } = data || {};

  useEffect(() => {
    const baseMap = {
      NUTRITION: productDetailedResponse,
      SEEDS: seedDetailedInformationResponse,
      FEED_SUPPLEMENT: feedSupplementDetailedResponse,
      MACHINERY: machineryDetailedResponse,
    };
    setDetail(baseMap[base] || {});
  }, [
    base,
    productDetailedResponse,
    seedDetailedInformationResponse,
    feedSupplementDetailedResponse,
    machineryDetailedResponse,
  ]);
  useEffect(() => {
    dispatch(
      GetProductDetails({
        productId: id,
        productBase: base,
      })
    );
  }, [id]);

  useEffect(() => {
    dispatch(
      detailsSaleListThunk({
        inventoryProductId: {
          inventoryId: storeId,
          productId: id,
        },
      })
    );
  }, [dispatch, storeId, id]);

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="d-flex flex-sm-nowrap flex-wrap justify-content-around justify-content-lg-between pb-6">
            <VendorStore />
            <TopRightLink
              name="View Inventory List"
              url={{
                pathname: "/Inventory",
                state: {
                  PagiNation: Pagination,
                  Filters: Filters,
                },
              }}
            />
          </div>
        </div>

        <CardWrapper>
          <CardHeader
            name={
              detail?.name?.en + " - " + detail?.productDetails?.brand?.name?.en
            }
            tooltipText={"View and manage product stock, pricing, sale details, and product information."}
          />
          <div className="card-body p-4">
            <Row gutter={[48, 48]}>
              <Col xs={24} lg={17}>
                <div
                  className="accordion accordion-solid accordion-toggle-plus"
                  id="vender_product_preview"
                >
                  <Variant
                    stockVariantData={variantData}
                    data={detail}
                    storeName={storeName}
                    storeId={storeId}
                    setInventoryValues={setInventoryValues}
                    inventoryValues={inventoryValues}
                    productId={id}
                  />
                  <Sale
                    stockVariantData={variantData}
                    data={detail}
                    storeId={storeId}
                    productId={id}
                  />
                  <ProductDetails data={detail} />
                  <About aboutItem={detail?.about} />

                  <TargetIndex
                    data={detail}
                    base={base}
                    storeId={storeId}
                    productId={id}
                  />
                </div>
              </Col>
              <Col xs={24} lg={7}>
                <MediaSlider
                  images={detail?.images?.map((obj) => obj.image)}
                  videos={detail?.videos}
                />
              </Col>
            </Row>
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default EditInventory;
